export enum ReportColumnSortDirection {
    undefined = 0,
    asc = 1,
    desc = 2
}
